import {
  fetchAll,
  createDocWithId,
  updateDocById,
  deleteDocById,
  uuidv4,
} from "./firestoreHelpers";

const COLL = "notas";

// Each entry: { idFirebase, titulo, contenido, categoria, estado (PENDIENTE/HECHA),
//   fijada, color, recordatorio (YYYY-MM-DD | ""), vinculoTipo (CONTRATO/PROPIEDAD/
//   LOCADOR/LOCATARIO/""), vinculoId, vinculoLabel, autorUid, autorNombre,
//   createdAt, updatedAt } -- las dos ultimas como ISO string.
export const getNotas = async () => fetchAll(COLL);

// Arma el registro completo (id + timestamps) del lado del cliente para que la
// UI pueda pintarlo antes de que Firestore confirme la escritura.
export const nuevaNota = (data) => {
  const ahora = new Date().toISOString();
  return { ...data, idFirebase: uuidv4(), createdAt: ahora, updatedAt: ahora };
};

export const saveNota = async (nota) =>
  createDocWithId(COLL, nota, nota.idFirebase);

// `data` ya viene con updatedAt puesto por quien llama, asi que lo que se
// guarda es identico a lo que quedo en pantalla.
export const updateNota = async (id, data) => updateDocById(COLL, id, data);

export const deleteNota = async (id) => deleteDocById(COLL, id);
